import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import moment from "moment";
import EndLiveStream from "../GeneralFunctions/EndLiveStream";
import ExtendTime from "../GeneralFunctions/ExtendTime";

function ExtendTimeModal(props) {
  const { setShowInformationStrip } = useLiveStreamAppContext();
  const { endCall } = EndLiveStream();
  const { extendTimeFunction } = ExtendTime();
  const [remainingTime, setRemainingTime] = useState(props.remainingTime);

  // Timer effect
  useEffect(() => {
    setShowInformationStrip(false);
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => Math.max(prevTime - 1, 0));
    }, 1000);
    return () => clearInterval(timer); // Cleanup interval on component unmount
  }, []);

  // Utility to format time
  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  //Function to Handle Extend Time Button Click
  function handleExtendTimeButton() {
    setShowInformationStrip(false);
    let meetingEndDate = moment(props.classEndTimeUTC)
      .add(10, "minutes")
      .local()
      .format("YYYY-MM-DDTHH:mm:ss");
    extendTimeFunction(meetingEndDate, 10);
    props.setDurationUpdated((prev) => prev + 10);
    props.onHide();
  }

  return (
    <Modal
      className="livestreamPopup liveStreamClassPopup"
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal-title">Your Live Stream Time is Almost Up</h4>
            {/* Cross Button */}
            <i
              className="font-awesome-light-pro live-popup-close"
              onClick={() => props.onHide()}
              style={{ cursor: "pointer" }}
            >
              &#xf00d;
            </i>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix default-scrollbar">
          <div className="discText">
            <p>
              You can extend your time to continue your live stream. Otherwise,
              you and your attendees will be automatically logged off when the
              time is up.
            </p>
          </div>
          {/* Timer */}
          <div className="leftTimeDiv">
            <span className="title-live-time">Time Left for Live Stream</span>
            <span className="live-time-remaining">
              {formatTime(remainingTime)}
            </span>
          </div>
        </Modal.Body>
        <Modal.Footer className="mobile-btn-row">
          <button
            className="cbtn brd-btn margin-right16 enroll-visits"
            onClick={() => {
              props.onHide(false);
              endCall();
            }}
          >
            End Live Stream
          </button>
          <button
            className="cbtn thm-btn enroll-visits"
            onClick={() => {
              handleExtendTimeButton();
            }}
          >
            Extend 10 Minutes
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default ExtendTimeModal;
